import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/loginQuestion',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-LoginQuestion" */ '~/pages/LoginQuestion'
        )
    ),
  },
  {
    path: '/loginQuestion/LoginQs',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-LoginQuestion-LoginQs" */ '~/pages/LoginQuestion/LoginQs'
        )
    ),
  },
  {
    path: '/loginQuestion/UpdatePassword',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-LoginQuestion-UpdatePassword" */ '~/pages/LoginQuestion/UpdatePassword'
        )
    ),
  },
] as RouteConfig[]
